export default __webpack_public_path__ + "static/media/DocPatient.867d4b63.svg";